import './LevelTest.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { navigationBarState } from '../../states/NavigationBar';
import { LoggedInState } from '../../states/LoggedIn';
import toast from 'react-hot-toast';

function LevelTest() {
    const navigate = useNavigate();
    const setNavigationBarState = useSetRecoilState(navigationBarState);
    const loggedIn = useRecoilValue(LoggedInState);
    const [isApplying, setIsApplying] = useState(false);
    const [showRetakeModal, setShowRetakeModal] = useState(false);

    // 레벨테스트 완료 여부
    const hasCompletedLevelTest = loggedIn?.user?.level_test?.status === 'EVALUATED';

    useEffect(() => {
        window.scrollTo(0, 0);
        setNavigationBarState({
            title: '레벨테스트',
            'left-item': { type: 'back' },
        });
    }, [setNavigationBarState]);

    const handleApplyClick = () => {
        // 이미 레벨테스트를 본 경우 확인 모달 표시
        if (hasCompletedLevelTest) {
            setShowRetakeModal(true);
        } else {
            applyLevelTest();
        }
    };

    const applyLevelTest = async () => {
        if (isApplying) return;

        setIsApplying(true);
        setShowRetakeModal(false);
        try {
            const response = await axios.post('/users/apply-level-test/');
            if (response.data.success) {
                toast.success('레벨테스트 신청이 완료되었습니다.');
                navigate('/tests');
            } else {
                toast.error(response.data.message || '신청에 실패했습니다.');
            }
        } catch (error) {
            toast.error(error.response?.data?.message || '신청에 실패했습니다.');
        } finally {
            setIsApplying(false);
        }
    };

    return (
        <div className="level-test-container">
            <div className="level-test-content">
                {/* Hero Section */}
                <div className="level-test-hero">
                    <div className="level-test-emoji">🎯</div>
                    <div className="level-test-title">
                        내 레벨에 맞는<br />시험을 찾아드려요
                    </div>
                    <div className="level-test-subtitle">
                        간단한 테스트로 맞춤 시험을 추천받으세요
                    </div>
                </div>

                {/* Info Chips */}
                <div className="level-test-chips">
                    <div className="level-test-chip">
                        <span className="level-test-chip-label">소요시간</span>
                        <span className="level-test-chip-value">약 10분</span>
                    </div>
                    <div className="level-test-chip-divider"></div>
                    <div className="level-test-chip">
                        <span className="level-test-chip-label">문항수</span>
                        <span className="level-test-chip-value">15문항</span>
                    </div>
                    <div className="level-test-chip-divider"></div>
                    <div className="level-test-chip">
                        <span className="level-test-chip-label">비용</span>
                        <span className="level-test-chip-value level-test-chip-free">무료</span>
                    </div>
                </div>

                {/* CTA Button */}
                <div className="level-test-cta">
                    <button
                        className="level-test-button"
                        onClick={handleApplyClick}
                        disabled={isApplying}
                    >
                        {isApplying ? '신청중...' : (hasCompletedLevelTest ? '재응시하기' : '신청하기')}
                    </button>
                </div>
            </div>

            {/* 재응시 확인 모달 */}
            {showRetakeModal && (
                <div className="level-test-modal-overlay" onClick={() => setShowRetakeModal(false)}>
                    <div className="level-test-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="level-test-modal-title">레벨테스트 재응시</div>
                        <div className="level-test-modal-description">
                            재응시하면 기존의 레벨테스트 기록이 삭제됩니다.
                        </div>
                        <div className="level-test-modal-buttons">
                            <button
                                className="level-test-modal-button cancel"
                                onClick={() => setShowRetakeModal(false)}
                            >
                                취소
                            </button>
                            <button
                                className="level-test-modal-button confirm"
                                onClick={applyLevelTest}
                            >
                                재응시하기
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default LevelTest;
